import { gsap } from 'gsap';

jQuery('body').on('added_to_cart', () => {
	const cartButton = document.querySelector('[data-cart-button]');

	if (!cartButton) return;

	const timeline = gsap.timeline();

	timeline
		.to(cartButton, {
			x: 16,
			duration: 0.3,
			ease: 'accelerateButton',
		})
		.to(cartButton, {
			x: 0,
			duration: 0.4,
			ease: 'slowDownButton',
			delay: 0.1,
		});
});

jQuery(window).on('load', () => {
	const currentPath = window.location.pathname;
	if (!currentPath.includes('/parduotuve') && !currentPath.includes('/shop'))
		return;

	const cartButton = document.querySelector('[data-cart-button]');

	if (!cartButton) return;

	gsap.to(cartButton, {
		x: 0,
		delay: 2.2,
		duration: 0.4,
		ease: 'headingEasing',
	});
});
